/**
 * Get the screen size variant according to window width.
 *
 * @return {string} Screen size variant.
 * */
// eslint-disable-next-line import/prefer-default-export
export function getScreenSizeVariant(): string {
  return window.innerWidth > 960 ? 'large' : 'small';
}
